import { Injectable } from '@angular/core';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

/** Um passo do tour: elemento a destacar + texto explicativo. */
export interface RaTourStep {
    /** Seletor CSS do elemento a ser destacado. */
    target: string;
    title?: string;
    description: string;
}

export interface RaTourConfig {
    steps: RaTourStep[];
    /** Chamado quando o tour termina — fechado pelo X, "Concluir", ESC ou clique fora. */
    onClose?: () => void;
}

/**
 * Wrapper reutilizável de tours guiados (spotlight num elemento + popover
 * explicativo). A API pública (`RaTourStep`/`RaTourConfig`) não expõe nada da
 * lib por baixo (hoje driver.js) — trocar de lib no futuro só exige mudar
 * este arquivo, nenhum chamador precisa saber que ela existe.
 * Tema aplicado globalmente via `.ra-guided-tour-popover` (ver
 * src/styles/guided-tour.scss).
 */
@Injectable({
    providedIn: 'root',
})
export class GuidedTourService {
    public show(config: RaTourConfig): void {
        if (config.steps.length === 0) return;

        const driverObj = driver({
            showProgress: config.steps.length > 1,
            allowClose: true,
            overlayOpacity: 0.6,
            popoverClass: 'ra-guided-tour-popover',
            steps: config.steps.map(step => ({
                element: step.target,
                // Impede clicar no alvo durante o tour: evita que uma ação do
                // elemento (ex.: entrar em edição de um campo) rode enquanto o
                // popover ainda está montado/manipulando o DOM por baixo.
                disableActiveInteraction: true,
                popover: {
                    title: step.title,
                    description: step.description,
                },
            })),
            onDestroyed: () => config.onClose?.(),
        });

        driverObj.drive();
    }
}
